import React from 'react';
import { Button, Col, Row } from '../../../../components';

export const FormActions = React.memo(({ onCancel, isLoading, isSaveDisabled = false }) => (
    <Row justify="end" gutter={[8, 8]}>
        <Col>
            <Button className={'action-btn'} size="large" onClick={onCancel}>
                Cancel
            </Button>
        </Col>
        <Col>
            <Button
                className={'action-btn'}
                size="large"
                type="primary"
                htmlType="submit"
                loading={isLoading}
                disabled={isSaveDisabled}
            >
                Save
            </Button>
        </Col>
    </Row>
));
